module.exports = __webpack_public_path__ + "img/ud_predictive_analytics_annuitycheck.4afb2104.svg";